/**
 * src/components/ui/Checkbox.tsx - COMPLETE CHECKBOX COMPONENT
 */

import React from 'react';
import { clsx } from 'clsx';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label?: string;
    error?: string;
    helperText?: string;
    containerClassName?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
                                                      label,
                                                      error,
                                                      helperText,
                                                      className,
                                                      containerClassName,
                                                      id,
                                                      ...props
                                                  }) => {
    const checkboxId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;

    return (
        <div className={clsx('flex items-start space-x-3', containerClassName)}>
            <div className="flex items-center h-5">
                <input
                    id={checkboxId}
                    type="checkbox"
                    className={clsx(
                        'h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
                        error && 'border-red-300 text-red-600 focus:ring-red-500',
                        props.disabled && 'opacity-50 cursor-not-allowed',
                        className
                    )}
                    {...props}
                />
            </div>

            <div className="flex-1">
                {label && (
                    <label
                        htmlFor={checkboxId}
                        className={clsx(
                            'text-sm font-medium text-gray-700 cursor-pointer',
                            props.disabled && 'opacity-50 cursor-not-allowed'
                        )}
                    >
                        {label}
                    </label>
                )}

                {helperText && !error && (
                    <p className="mt-1 text-xs text-gray-500">{helperText}</p>
                )}

                {error && (
                    <p className="mt-1 text-xs text-red-600">{error}</p>
                )}
            </div>
        </div>
    );
};